/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon20Light = forwardRef('ArrowShapeTriangleARightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5.121a1.1 1.1 0 0 1 1.71-.915l7.318 4.879a1.1 1.1 0 0 1 0 1.83l-7.318 4.88A1.1 1.1 0 0 1 6 14.878V5.121Zm1.155-.083A.1.1 0 0 0 7 5.121v9.758a.1.1 0 0 0 .155.083l7.319-4.878a.1.1 0 0 0 0-.167L7.155 5.038Z" })));
});
